/**
 * Parses a date string and returns a valid Date object, or falls back to a default date if parsing fails.
 * @param dateString - The date string to parse (can be null)
 * @param fallback - The fallback Date to return if parsing fails or dateString is null
 * @returns A valid Date object, either the parsed date or the fallback
 */
export function parseDate(dateString: string | null, fallback: Date): Date {
  if (!dateString) return fallback;
  const parsed = new Date(dateString);
  return !isNaN(parsed.getTime()) ? parsed : fallback;
}
